"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidRFRegion = exports.RFRegions = exports.LFCExpectedMessagePorts = exports.DownlinkAction = exports.Networks = void 0;
var Networks;
(function (Networks) {
    Networks["AWS_LPWAN"] = "AWS_LPWAN";
    Networks["Chirpstack"] = "Chirpstack";
    Networks["Helium"] = "Helium";
    Networks["Interceptor"] = "Interceptor";
    Networks["ThingPark"] = "ThingPark";
    Networks["TTN_Community"] = "TTN_Community";
    Networks["TTN_Enterprise"] = "TTN_Enterprise";
})(Networks || (exports.Networks = Networks = {}));
var DownlinkAction;
(function (DownlinkAction) {
    DownlinkAction["PUSH"] = "PUSH";
    DownlinkAction["REPLACE"] = "REPLACE";
})(DownlinkAction || (exports.DownlinkAction = DownlinkAction = {}));
exports.LFCExpectedMessagePorts = {
    /** Port `0` indicates that the `FRMPayload` contains MAC commands only */
    DEFAULT_PORT: 2,
    /** Used by `Elsys` sensor devices for their main data uplink, which we call the "app" uplink */
    ELSYS_DATA: 5,
    /** Used by `Elsys` sensor devices for their configuration data uplink, which we call the "sys" uplink */
    ELSYS_CONFIG: 6,
    /** Used for device settings */
    SETTINGS_PORT: 97,
    /** Used for config payloads */
    CONFIG_PORT: 98,
    /** Used for system payloads */
    SYSTEM_PORT: 99,
};
exports.RFRegions = {
    AU915: 'AU915',
    EU868: 'EU868',
    EU433: 'EU433',
    CN470: 'CN470',
    CN779: 'CN779',
    RU864: 'RU864',
    KR920: 'KR920',
    IN865: 'IN865',
    US915: 'US915',
    'AS923-1': 'AS923-1',
    'AS923-2': 'AS923-2',
    'AS923-3': 'AS923-3',
    'AS923-4': 'AS923-4',
};
const isValidRFRegion = (x) => {
    return typeof x === 'string' && Object.values(exports.RFRegions).includes(x);
};
exports.isValidRFRegion = isValidRFRegion;
